export default __webpack_public_path__ + "static/media/slides.a69e0682.svg";